// export class HeaderRenderer extends HeaderComp {
//   private eLabel: HTMLElement | null = null
//   private params: IHeaderParams | null = null

import { type IHeaderParams } from "@ag-grid-community/core"

//   init(params: IHeaderParams) {
//     console.log('BLAH', params)
//     super.init(params)

//     this.displayLabel = 'bla'
//   }

//   setupSort() {
//     const originalELabel = this.eLabel

//     // when eLabel is null, the click event is not being handled thus sorting is disabled
//     if (this.params?.context?.disableSort) {
//       this.eLabel = null
//     }
//     super.setupSort()
//     this.eLabel = originalELabel
//   }
// }

export class HeaderRenderer {
  agParams!: IHeaderParams
  eGui!: HTMLElement
  eMenu: HTMLElement | null = null
  eLabel: HTMLElement | null = null
  eText: HTMLElement | null = null
  eFilter: HTMLElement | null = null
  eSortIndicator: HTMLElement | null = null
  eSortOrder: HTMLElement | null = null
  eSortAsc: HTMLElement | null = null
  eSortDesc: HTMLElement | null = null
  eSortMixed: HTMLElement | null = null
  eSortNone: HTMLElement | null = null
  onMenuClickListener: (() => void) | null = null
  onSortChangedListener: (() => void) | null = null
  onLabelClickListener: ((event: MouseEvent) => void) | null = null

  init(agParams: IHeaderParams) {
    this.agParams = agParams
    this.eGui = document.createElement("div")

    const columnDef = this.agParams.column.getUserProvidedColDef() as {
      params: {
        header: string
      }
      cellDataType: string
    }

    const columnType = this.agParams.column.getColDef().type
    const isRightAligned = [
      "numberColumn",
      "trendingColumn",
      "trendingInverseColumn",
    ].includes(String(Array.isArray(columnType) ? columnType[0] : columnType))

    const params = columnDef?.params || {}

    const sortIcon = `<span class="ag-sort-indicator-container ${isRightAligned ? "pr-2" : "pl-2"}" ref="eSortIndicator">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true" style="padding: 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 256 256" style="color: var(--ho42o72t); width: 16px; height: 16px;"><path opacity="0.2" d="M176 168H80C78.4168 167.999 76.8689 168.467 75.5521 169.346C74.2354 170.225 73.209 171.475 72.603 172.938C71.997 174.4 71.8386 176.01 72.1478 177.562C72.457 179.115 73.2199 180.541 74.34 181.66L122.34 229.66C123.083 230.404 123.965 230.994 124.936 231.396C125.908 231.799 126.949 232.006 128 232.006C129.051 232.006 130.092 231.799 131.064 231.396C132.035 230.994 132.917 230.404 133.66 229.66L181.66 181.66C182.78 180.541 183.543 179.115 183.852 177.562C184.161 176.01 184.003 174.4 183.397 172.938C182.791 171.475 181.765 170.225 180.448 169.346C179.131 168.467 177.583 167.999 176 168Z"></path><path d="M72.1523 78.4376C71.8443 79.9898 72.0036 81.5984 72.61 83.06C73.2152 84.5219 74.2403 85.7716 75.5557 86.6509C76.8711 87.5302 78.4178 87.9997 80 88H176C177.583 88.0013 179.131 87.5327 180.448 86.6538C181.765 85.7748 182.791 84.5249 183.397 83.0623C184.003 81.5997 184.161 79.9902 183.852 78.4376C183.543 76.8849 182.78 75.4588 181.66 74.34L133.66 26.34C132.917 25.5962 132.035 25.0061 131.064 24.6035C130.092 24.2009 129.051 23.9937 128 23.9937C126.949 23.9937 125.908 24.2009 124.936 24.6035C123.965 25.0061 123.083 25.5962 122.34 26.34L74.34 74.34C73.2215 75.4594 72.4602 76.8854 72.1523 78.4376Z"></path></svg>
            </span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true" style="padding: 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 256 256" style="color: var(--ho42o72t); width: 16px; height: 16px;"><path d="M176 168H80C78.4168 167.999 76.8689 168.467 75.5521 169.346C74.2354 170.225 73.209 171.475 72.603 172.938C71.997 174.4 71.8386 176.01 72.1478 177.562C72.457 179.115 73.2199 180.541 74.34 181.66L122.34 229.66C123.083 230.404 123.965 230.994 124.936 231.396C125.908 231.799 126.949 232.006 128 232.006C129.051 232.006 130.092 231.799 131.064 231.396C132.035 230.994 132.917 230.404 133.66 229.66L181.66 181.66C182.78 180.541 183.543 179.115 183.852 177.562C184.161 176.01 184.003 174.4 183.397 172.938C182.791 171.475 181.765 170.225 180.448 169.346C179.131 168.467 177.583 167.999 176 168Z"></path><path opacity="0.2" d="M72.1523 78.4376C71.8443 79.9898 72.0036 81.5984 72.61 83.06C73.2152 84.5219 74.2403 85.7716 75.5557 86.6509C76.8711 87.5302 78.4178 87.9997 80 88H176C177.583 88.0013 179.131 87.5327 180.448 86.6538C181.765 85.7748 182.791 84.5249 183.397 83.0623C184.003 81.5997 184.161 79.9902 183.852 78.4376C183.543 76.8849 182.78 75.4588 181.66 74.34L133.66 26.34C132.917 25.5962 132.035 25.0061 131.064 24.6035C130.092 24.2009 129.051 23.9937 128 23.9937C126.949 23.9937 125.908 24.2009 124.936 24.6035C123.965 25.0061 123.083 25.5962 122.34 26.34L74.34 74.34C73.2215 75.4594 72.4602 76.8854 72.1523 78.4376Z"></path></svg>
            </span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true" style="padding: 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 256 256" style="opacity: 0.25; width: 16px; height: 16px;"><path d="M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06ZM176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z"></path></svg>
            </span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon" aria-hidden="true" style="padding: 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 256 256" style="opacity: 0.25; width: 16px; height: 16px;"><path d="M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06ZM176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z"></path></svg>
            </span>
          </span>`

    const headingMenu = `<span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 256 256" style="fill: hsl(var(--fg-secondary))">
                  <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"></path>
                </svg>
              </span>`

    this.eGui.innerHTML = `
      <div class="ag-cell-label-container w-full" role="presentation">
        ${this.agParams.enableMenu && !isRightAligned ? headingMenu : ""}
        <div ref="eLabel" class="ag-header-cell-label ${isRightAligned ? "justify-end" : "justify-start"}" role="presentation">
        ${this.agParams.enableSorting && isRightAligned ? sortIcon : ""}
          <div class='flex flex-col'>
            ${
              params?.header
                ? `<span ref="eText" class="ag-header-cell-text font-medium text-fg-secondary">
                    ${params?.header}
                  </span>
                  <span class="ag-header-cell-text text-fg-secondary text-xs">
                    ${this.agParams.displayName}
                  </span>`
                : `<span ref="eText" class="ag-header-cell-text font-medium text-fg-secondary">
                ${this.agParams.displayName}
              </span>`
            }
              </div>
              ${this.agParams.enableSorting && !isRightAligned ? sortIcon : ""}
          <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon ag-hidden" aria-hidden="true">
          hello
            <svg width="12" height="12"><use xlink:href="#filter"></use></svg>
          </span>
        </div>
        ${this.agParams.enableMenu && isRightAligned ? headingMenu : ""}
      </div>
    `

    // Get references to the elements
    this.eMenu = this.eGui.querySelector('[ref="eMenu"]')
    this.eLabel = this.eGui.querySelector('[ref="eLabel"]')
    this.eText = this.eGui.querySelector('[ref="eText"]')
    this.eFilter = this.eGui.querySelector('[ref="eFilter"]')
    this.eSortIndicator = this.eGui.querySelector('[ref="eSortIndicator"]')
    this.eSortOrder = this.eGui.querySelector('[ref="eSortOrder"]')
    this.eSortAsc = this.eGui.querySelector('[ref="eSortAsc"]')
    this.eSortDesc = this.eGui.querySelector('[ref="eSortDesc"]')
    this.eSortMixed = this.eGui.querySelector('[ref="eSortMixed"]')
    this.eSortNone = this.eGui.querySelector('[ref="eSortNone"]')

    if (this.agParams.enableMenu && this.eMenu) {
      this.onMenuClickListener = this.onMenuClick.bind(this)
      this.eMenu.addEventListener("click", this.onMenuClickListener)
    }

    if (this.agParams.enableSorting && this.eLabel) {
      this.onLabelClickListener = this.onLabelClick.bind(this)
      this.eLabel.addEventListener("click", this.onLabelClickListener)
      this.onSortChangedListener = this.onSortChanged.bind(this)
      this.agParams.column.addEventListener(
        "sortChanged",
        this.onSortChangedListener
      )
      this.onSortChanged()
    }
  }

  onSortChanged() {
    const sort = this.agParams.column.getSort()

    // Hide all sort indicators first
    if (this.eSortOrder) this.eSortOrder.classList.add("ag-hidden")
    if (this.eSortAsc) this.eSortAsc.classList.add("ag-hidden")
    if (this.eSortDesc) this.eSortDesc.classList.add("ag-hidden")
    if (this.eSortMixed) this.eSortMixed.classList.add("ag-hidden")
    if (this.eSortNone) this.eSortNone.classList.add("ag-hidden")
    if (this.eText)
      this.eText.classList.remove("text-fg-primary", "text-fg-secondary")

    // Show the appropriate sort indicator
    if (sort === "asc" && this.eSortAsc) {
      this.eSortAsc.classList.remove("ag-hidden")
      this.eText?.classList.add("text-fg-primary")
    } else if (sort === "desc" && this.eSortDesc) {
      this.eSortDesc.classList.remove("ag-hidden")
      this.eText?.classList.add("text-fg-primary")
    } else if ((sort === undefined || sort === null) && this.eSortNone) {
      this.eSortNone.classList.remove("ag-hidden")
      this.eText?.classList.add("text-fg-secondary")
    }
  }

  getGui() {
    return this.eGui
  }

  onMenuClick() {
    if (this.eMenu) {
      this.agParams.showColumnMenu(this.eMenu)
    }
  }

  onLabelClick(event: MouseEvent) {
    const currentSort = this.agParams.column.getSort()
    let newSort: "asc" | "desc" | null = "asc"

    if (currentSort === "asc") {
      newSort = "desc"
    } else if (currentSort === "desc") {
      newSort = null
    }

    this.agParams.setSort(newSort, event.shiftKey)
  }

  destroy() {
    if (this.onMenuClickListener && this.eMenu) {
      this.eMenu.removeEventListener("click", this.onMenuClickListener)
    }
    if (this.onLabelClickListener && this.eLabel) {
      this.eLabel.removeEventListener("click", this.onLabelClickListener)
    }
    if (this.onSortChangedListener) {
      this.agParams.column.removeEventListener(
        "sortChanged",
        this.onSortChangedListener
      )
    }
  }
}
